/* eslint-disable no-undef */
import styled from 'styled-components';
import BuyIconDark from '../../assets/images/buy-icon.svg';
import BuyIconLight from '../../assets/images/buy-icon-light.svg';

const BuyIcon = styled.span`
  background: ${(props) =>
    props.theme.palette.type === 'dark'
      ? `url("${BuyIconDark}") no-repeat left center`
      : `url("${BuyIconLight}") no-repeat left center`};
  background-size: 23px 21px;
  display: inline-block;
  position: relative;
  vertical-align: middle;
  height: 21px;
  width: 23px;
`;

export default BuyIcon;
